import { type KeyboardEvent } from 'react'
import { observer } from 'mobx-react-lite'
import { type Observable } from 'rxjs'
import { type NumericQuestionAnswerEditorViewModel } from '@/features/jobs/questions/numeric/NumericQuestionAnswerEditorViewModel'
import { NumericQuestionAnswerEditor } from '@/features/jobs/questions/numeric/components/NumericQuestionAnswerEditor'

export interface NumericQuestionAnswerEditorContainerProps {
  editorVm: NumericQuestionAnswerEditorViewModel
  questionId: string
  isDisabled: boolean
  focus$?: Observable<unknown>
  onFocus?: () => unknown
  onEnterDown?: (e: KeyboardEvent) => unknown
  isNotValid?: boolean
}

export const NumericQuestionAnswerEditorContainer = observer(
  function NumericQuestionAnswerEditorContainer({
    editorVm,
    questionId,
    ...rest
  }: NumericQuestionAnswerEditorContainerProps) {
    return (
      <NumericQuestionAnswerEditor
        value={editorVm.value}
        decimalPlaces={editorVm.decimalPlaces}
        onChange={editorVm.respond}
        testId={`numeric-answer-${questionId}`}
        {...rest}
      />
    )
  },
)
